import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";

export const Wrapper = withViewportStyle("div")`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  padding: ${rem(177)} ${rem(24)};
  min-height: ${rem(780)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(48)} ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
    min-height: ${rem(644)};
  `}
`;

export const Content = styled.div`
  position: relative;
  display: grid;
  grid-row-gap: ${rem(24)};
  align-content: center;
  max-width: ${rem(1016)};

  .crosby .ck-content h1,
  .crosby .ck-content h2,
  .crosby .ck-content h3,
  .crosby .ck-content h4,
  .crosby .ck-content h5,
  .crosby .ck-content p,
  .crosby .ck-content li {
    color: #fff;
    margin: 0;
  }
`;

export const TextContent = styled.div`
  display: grid;
  grid-row-gap: ${rem(16)};
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;

  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
  }
`;

export const Image = styled.img<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.imageFit || "cover"};
  object-position: ${(props) => props.$position};
  overflow: hidden;
`;

export const LogoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = withViewportStyle("img")<{ isLogoResized: boolean }>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(35))};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(32))};
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 0 auto;
  max-width: ${rem(300)};

  .button-primitive {
    ${baseButtonStyle}
    width: 100%;
  }
`;
